import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";

const Footer = ({ settings }) => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#161311] text-[#E8DFCF] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <h3 className="font-serif-display text-3xl tracking-wide mb-4">
            SHAURYA <span className="opacity-60">TRAVELS</span>
          </h3>
          <p className="text-sm opacity-70 leading-relaxed max-w-xs">
            Curated journeys, captured stories. Every photograph is an invitation.
          </p>
          <p className="text-xs opacity-50 leading-relaxed mt-6">
            A registered travel agency based in Pune, Maharashtra, India. Serving travellers since
            our beginnings on the road.
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] opacity-60 mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-[var(--st-accent)] transition" data-testid="footer-home-link">Home</Link></li>
            <li><Link to="/destinations" className="hover:text-[var(--st-accent)] transition" data-testid="footer-destinations-link">Destinations</Link></li>
            <li><Link to="/vehicles" className="hover:text-[var(--st-accent)] transition" data-testid="footer-vehicles-link">Vehicles</Link></li>
            <li><Link to="/gallery" className="hover:text-[var(--st-accent)] transition" data-testid="footer-gallery-link">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-[var(--st-accent)] transition" data-testid="footer-about-link">About</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--st-accent)] transition" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] opacity-60 mb-5">Reach Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><Mail size={16} className="mt-1 text-[var(--st-accent)]" /><a className="hover:text-white transition" href={`mailto:${settings?.contact_email || ''}`}>{settings?.contact_email || "—"}</a></li>
            <li className="flex items-start gap-3"><Phone size={16} className="mt-1 text-[var(--st-accent)]" /><a className="hover:text-white transition" href={`tel:${(settings?.contact_phone || '').replace(/\s/g, '')}`}>{settings?.contact_phone || "—"}</a></li>
            <li className="flex items-start gap-3"><MapPin size={16} className="mt-1 text-[var(--st-accent)]" /><span>{settings?.contact_address || "Pune, India"}</span></li>
            <li className="flex items-start gap-3"><Instagram size={16} className="mt-1 text-[var(--st-accent)]" /><span>@shauryatravels</span></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] opacity-60 mb-5">Legal</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/privacy" className="hover:text-[var(--st-accent)] transition" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-[var(--st-accent)] transition" data-testid="footer-terms-link">Terms of Service</Link></li>
            <li><Link to="/terms" className="hover:text-[var(--st-accent)] transition" data-testid="footer-refund-link">Cancellation & Refund</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between text-xs opacity-60 gap-2">
          <span>© {new Date().getFullYear()} Shaurya Travels. All rights reserved.</span>
          <span>Pune, Maharashtra, India · Crafted with wanderlust.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
